import { useState, useEffect } from "react";
import "../../style/scss/AutoComplete.scss";

export default function Autocomplete({
  options = [],
  onSelect,
  onChange,
  onInputChange,
  value,
  placeholder,
  className,
  label,
}) {
  const [inputValue, setInputValue] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    if (value !== undefined && value !== inputValue) {
      setInputValue(value || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    const list = Array.isArray(options) ? options : [];
    const filtered = list.filter(
      (option) =>
        typeof option === "string" &&
        option.toLowerCase().includes((inputValue || "").toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [inputValue, options]);

  const handleInputChange = (e) => {
    const next = e.target.value;
    setInputValue(next);
    setShowSuggestions(true);
    if (onInputChange) onInputChange(e, next);
  };

  const handleOptionClick = (option) => {
    setInputValue(option);
    setShowSuggestions(false);
    if (onSelect) onSelect(option);
    if (onChange) onChange(null, option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".autocomplete")) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={"autocomplete " + (className || "")}>
      {label ? <label className="form-label">{label}</label> : null}
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder || "Type to search..."}
        aria-label={label || placeholder || "Autocomplete"}
      />
      {showSuggestions && filteredOptions.length > 0 && (
        <ul className="suggestions">
          {filteredOptions.map((option, index) => (
            <li key={index} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
